// src/shared/offlineManager.ts
import mitt from "mitt";
import { updateIndexDBSettings } from "../db";

type OfflineEvents = { change: boolean };
const emitter = mitt<OfflineEvents>();

const LS_KEY = "isOfflineMode";
const BC_NAME = "offline-mode";;

let state = readFromLocalStorage();
const channel = new BroadcastChannel(BC_NAME);

/* ------------------ Public API ------------------ */

export const isOfflineMode = () => state;

export function turnOfflineModeOn() {
  updateState(true);
}

export function turnOfflineModeOff() {
  updateState(false);
}

export function toggleOfflineMode() {
  updateState(!state);
}

export function onOfflineModeChange(callback: (value: boolean) => void) {
  emitter.on("change", callback);
  return () => emitter.off("change", callback); // unsubscribe function
}

/* ------------------ Internals ------------------ */

function updateState(newValue: boolean) {
  if (state === newValue) return;
  state = newValue;
  writeToLocalStorage(newValue);
  channel.postMessage(newValue);
  emitter.emit("change", newValue);

  // save setting to indexDB for servie worker access, service worker can't access local storage
  updateIndexDBSettings("offlineMode", newValue);
}

function readFromLocalStorage(): boolean {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) ?? "false");
  } catch {
    return false;
  }
}

function writeToLocalStorage(value: boolean) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(value));
  } catch {
    // Silent fail if storage quota exceeded
  }
}

channel.onmessage = (event) => {
  updateState(event.data);
};
